module.exports = __webpack_public_path__ + "static/media/year2023_1-tc.1f80ed82.jpg";